import React from 'react';
import { Container, Typography, Box, Paper, Grid, Button, Card, CardContent, Divider, useTheme, useMediaQuery } from '@mui/material';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';

import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import FavoriteIcon from '@mui/icons-material/Favorite';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InfoIcon from '@mui/icons-material/Info';
import CodeIcon from '@mui/icons-material/Code';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import BuildIcon from '@mui/icons-material/Build';
import EmailIcon from '@mui/icons-material/Email';
import { DonateSEO } from '../components/SEOPages';

const Donate = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  

  
  return (
    <>
      <DonateSEO />
      <DonateContent theme={theme} isMobile={isMobile} />
    </>
  );
};

const DonateContent = ({ theme, isMobile }) => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 3 }}>
          <VolunteerActivismIcon sx={{ mr: 1, verticalAlign: 'middle', fontSize: 35, color: theme => theme.palette.success.main }} />
          支持股票信号网
        </Typography>
        
        {/* 支持部分 - 根据设备类型显示不同内容 */}
        <Paper elevation={3} sx={{ p: 3, mb: 4, backgroundColor: theme => theme.palette.mode === 'dark' ? theme.palette.background.paper : '#f8f9fa', borderRadius: 3, border: theme => `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : '#e0e0e0'}` }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FavoriteIcon sx={{ mr: 1, color: theme => theme.palette.error.main }} />
              支付宝扫码支持
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
            <Box 
              sx={{ 
                width: isMobile ? 160 : 180, 
                height: isMobile ? 160 : 180, 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundImage: 'url(/qrcode.png)',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: 2,
                border: theme => `1px solid ${theme.palette.divider}`
              }}
            />
            <Box sx={{ textAlign: isMobile ? 'center' : 'left', maxWidth: 280 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
                {isMobile ? '长按识别二维码' : '扫描二维码进行捐助'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
                您的每一份支持都是我们前进的动力
              </Typography>
              <Button 
                variant="outlined" 
                color="primary" 
                size="small"
                startIcon={<FavoriteIcon />}
                sx={{ 
                  mt: 2, 
                  px: 3, 
                  py: 0.8, 
                  borderRadius: 3,
                  fontSize: '0.875rem'
                }}
              >
                感谢支持
              </Button>
            </Box>
          </Box>
        </Paper>

        <Paper elevation={3} sx={{ p: 4, mb: 5, borderRadius: 3, border: theme => `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : '#e0e0e0'}` }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: 'primary.main', display: 'flex', alignItems: 'center' }}>
            <InfoIcon sx={{ mr: 1, color: theme => theme.palette.info.main }} />
            关于我们
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            股票信号网是一个完全免费的投资信息平台，致力于为广大投资者提供有价值的股票数据和分析工具。我们承诺永远不向用户收取任何费用。
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            为了保证数据的实时性和稳定性，我们使用高性能的香港云服务器，并采用CN2专线优化国内访问速度。然而，优质的服务器资源和带宽成本不菲，这给我们的运营带来了不小的压力。
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            我们的初心是为投资者创造价值，而非盈利。如果您认为我们的服务对您的投资决策有所帮助，我们真诚希望能够得到您的支持和捐助，这将帮助我们持续改进服务质量。
          </Typography>
          <Box sx={{ mt: 3, p: 2.5, bgcolor: theme => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50', borderRadius: 2, border: theme => `1px solid ${theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200'}` }}>
             <Box sx={{ fontSize: '0.9rem', color: 'text.secondary', lineHeight: 1.6, display: 'flex', alignItems: 'flex-start' }}>
               <Box component="span" sx={{ mr: 1, fontSize: '1rem' }}>💡</Box>
               <Box>
                 <Box component="span" sx={{ fontWeight: 'bold', color: 'text.primary' }}>温馨提示：</Box>
                 为了减轻运营成本压力，我们可能会在网站的适当位置展示一些精选的合作伙伴推广内容。这些内容都经过我们的筛选，确保与投资理财相关且具有一定价值。点击这些链接可能会为我们带来少量推广收益，用于维持服务器运行和功能开发。感谢您的理解与支持！
               </Box>
             </Box>
           </Box>
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 4, p: 3, borderTop: theme => `1px solid ${theme.palette.divider}` }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: theme => theme.palette.success.main }}>
            感谢您的支持！
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <EmailIcon sx={{ mr: 1, fontSize: 18 }} />
            如有任何问题或建议，请联系我们：support@stocksignals.cn
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Donate;